import React from "react";
import styled from "styled-components";
import habitatLogo from "../assets/images/logos/Buffalo_Hz_2clr.webp"; // Import the logo image
import roof from "../assets/images/stock-photos/roof.webp"; // Import the image

const HabitatComponent = () => {
  return (
    <Container>
      <TextContent>
        <Logo src={habitatLogo} alt="Habitat for Humanity Buffalo Logo" />
        <Subtitle>
          We build strength, stability, and self-reliance through shelter.
        </Subtitle>
        <Description>
          At the core of Habitat’s mission is the idea of people coming
          together, working together, building together, and helping one
          another.
        </Description>
        <LearnMoreButton href="/who-we-are">Learn More</LearnMoreButton>
      </TextContent>
      <ImageContent>
        <StyledImage src={roof} alt="Habitat volunteer working on a roof" />
      </ImageContent>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 50px;
  background-color: var(--background-color);
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px;
  }
`;

const TextContent = styled.div`
  max-width: 30%;
  margin: 0 auto;
  @media (max-width: 768px) {
    max-width: 100%;
    text-align: center;
  }
`;

const Logo = styled.img`
  width: 100%;
  max-width: 300px;
  margin-bottom: 20px;
`;

const Subtitle = styled.h2`
  font-size: var(--font-size-heading);
  color: var(--text-color);
  margin-bottom: 20px;
  text-align: left;
`;

const Description = styled.p`
  font-size: var(--font-size-body);
  color: var(--text-color);
  margin-bottom: 20px;
`;

const LearnMoreButton = styled.a`
  display: inline-block;
  background-color: var(--primary-color);
  color: var(--secondary-color);
  padding: 20px 40px;
  border: none;
  border-radius: 5px;
  font-size: var(--font-size-body);
  cursor: pointer;
  text-decoration: none;
  &:hover {
    background-color: var(--accent-color);
  }
`;

const ImageContent = styled.div`
  max-width: 45%;
  @media (max-width: 768px) {
    max-width: 100%;
    margin-top: 20px;
  }
`;

const StyledImage = styled.img`
  width: 100%;
  border-radius: 10px;
`;

export default HabitatComponent;
